import { Component, ViewChild, ChangeDetectorRef, ElementRef  } from '@angular/core'
import {
    IonicPage, NavController, NavParams, AlertController, ModalController, LoadingController,
    Loading, Content, Platform, PopoverController, ToastController, Searchbar, Events,
    DateTime
} from 'ionic-angular';
import { FormControl } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Page } from '../../enums/page.enum';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

/* Models */
import { CustomerModel } from '../../models/customer/customer.model';
import { ShiptoModel } from '../../models/customer/shipto.model';
import { SalesOrgModel } from '../../models/customer/salesorg.model';
import { TransactionModel } from '../../models/order/transaction.model';
import { OrderHeaderModel } from '../../models/order/orderheader.model';
// STRY0018386- Same process for payer & billto code on copy txn
import { PayerModel } from '../../models/customer/payer.model';

/* Filters & Services */
import { TxnStatusFilter } from '../../filters/txnstatus.pipe';
import { TxnHistFilter } from '../../filters/txnHistFilter.pipe';
import { NumFormatter } from '../../filters/num-formatter.pipe';
import { ErrorLogService } from '../../services/errorlog.service';
import { TransactionService } from '../../services/transaction.service';
import { UtilService } from '../../services/util.service';
import { BadgeService } from '../../services/badge.service';
import { StorageService } from '../../services/storage.service';
import { CustomerService } from '../../services/customer.service';
import * as _ from "lodash";
import { SettingId } from '../../enums/settingid.enum';
import { QuoteStatus } from '../../enums/quotestatus.enum';
import { AuthWrapper } from '../../infra/authWrapper';
import { Setups } from '../../services/setup';
import { ModalAction } from '../../enums/modalaction.enum';
import { SalesInd } from '../../enums/salesind.enum';
import { CopyOrderInfoModel } from '../../models/order/copyorderinfo.model';

@IonicPage()
@Component({
    selector: 'txn-history',
    templateUrl: 'txn-history.html',
    providers: [TxnStatusFilter, TxnHistFilter, NumFormatter]
})
export class TxnHistory {
    @ViewChild(Content) content: Content;
    @ViewChild('searchbar') searchbar: Searchbar;
    @ViewChild('filterTrigger') filterTrigger: ElementRef;

    term = new FormControl();
    txnDtl: TransactionModel;
    txnList: TransactionModel[] = [];
    order: OrderHeaderModel;
    loading : Loading;
    showFilter: Boolean = false;
    showScrollToTop: Boolean = false;
    bottomPixel: string = "";
    direction: string = "";
    searchTerm: string = "";
    pageIndex: number = 0;
    selectedTxnStatus: string;
    selectedTxnDivision: string;
    selectedTxnStartDate: string = "";
    selectedTxnEndDate: string = "";
    selectedCustCode: any = "";
    selectedSalesOrg: any = "";
    selectedShiptoCode: any = "";
    selectedDivision: any = "";
    selectedDistchannel: any = "";
    selectedPayTerm: any = "";
    isFirstLoad: Boolean = true;
    salesorg?: SalesOrgModel[];
     // STRY0018386- Same process for payer & billto code on copy txn
    payer?: PayerModel[];
    isVN: Boolean = false;
    showPills = false;
    custRestrictionPolicy: string = "";
    filterByOrderType:any= ""
    private isTransactionTab = false;
    private isLoading: boolean = false;
    private scrollSubscription: any = null;
    private filterPopoverRef: any = null;
    private dismissedFilterByOutsideClick = false;
    private refocusSearchTxnInputTimer: any = null;
    isFilterOpen: boolean = false;
    private requestSeq: number = 0;
    private filterDismissedViaSelection = false;

    constructor(
        private storage: Storage,
        public navCtrl: NavController,
        public navParams: NavParams,
        private transactionService: TransactionService,
        private badgeService: BadgeService,
        private util: UtilService,
        public storageService: StorageService,
        private events: Events,
        private modalCtrl: ModalController,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController,
        private toastCtrl: ToastController,
        private platform: Platform,
        public popoverCtrl: PopoverController,
        private changeDetectorRef: ChangeDetectorRef,
        public setups: Setups,
        private customerService: CustomerService,
        private authWrapper: AuthWrapper
    )
    {
        this.selectedTxnStatus = "";
        this.selectedTxnDivision = "";
        this.isVN = this.util.isRemoveDKSHLogoForVN();
    }

    filterByPills = [
        { id: 'so', label: 'SO No.', active: true, color: 'light' },
        { id: 'shiptoCode',label: 'Ship To Code', active: false, color: 'light' },
        { id: 'shiptoName', label: 'Ship To Name', active: false, color: 'light' },
        { id: 'order', label: 'Transaction No.', active: false, color: 'light' },
        { id: 'customerCode', label: 'Sold To Code', active: false, color: 'light' },
        { id: 'customerName', label: 'Sold To Name', active: false, color: 'light' },
    ];

    get selectedFilterLabel(): string {
        const active = this.filterByPills.find(p => p.active);
        return (active || this.filterByPills[0]).label;
    }

    toggleFilterPopover(ev?: any) {
        if (ev && ev.type === 'keydown') { ev.preventDefault(); }
        if (this.filterPopoverRef) {
            this.filterPopoverRef.dismiss();
        } else {
            this.showFilterPopover(ev);
        }
    }

    getActivePillIds(): string[] {
        return this.filterByPills.filter(p => p.active).map(p => p.id);
    }

    searchTransaction() {
        if (this.filterPopoverRef) {
            this.filterPopoverRef.dismiss();
        }

        const activePillId = this.filterByPills.find(p => p.active)?.id || '';
        this.retrieveTransactionList(undefined, undefined, activePillId);
    }

    private safelyDismissLoading() {
        if (this.loading) {
            try { this.loading.dismiss(); }
            finally { this.loading = null; }
        }
    }

    showFilterPopover(ev?: any) {
        if (this.filterPopoverRef) return;

        document.body.classList.add('filter-pills-open');
        this.isFilterOpen = true;

        this.filterPopoverRef = this.popoverCtrl.create(
            'TxnHistSearchFilterPopover',
            {
                pills: this.filterByPills.map(p => ({ ...p })),
                onPopoverReady: () => this.positionFilterPopover(),
                onPillSelected: (pillId: string) => this.onPillSelectedFromPopover(pillId)
            },
            { cssClass: 'filter-pills-popover', enableBackdropDismiss: true, showBackdrop: false }
        );

        this.filterPopoverRef.present({ ev: ev });

        setTimeout(() => {
            if (this.filterPopoverRef) {
                document.addEventListener('click', this.handleOutsideClick, true);
            }
        }, 0);
        setTimeout(() => this.positionFilterPopover(), 50);

        this.filterPopoverRef.onDidDismiss(() => {
            document.body.classList.remove('filter-pills-open');
            document.removeEventListener('click', this.handleOutsideClick, true);
            this.filterPopoverRef = null;
            this.isFilterOpen = false;

            if (!this.filterDismissedViaSelection && !this.dismissedFilterByOutsideClick && this.filterTrigger) {
                this.filterTrigger.nativeElement.focus();
            }

            this.dismissedFilterByOutsideClick = false;
            this.filterDismissedViaSelection = false;
        });
    }

    private positionFilterPopover() {
        const contentEl = document.querySelector('.filter-pills-popover .popover-content') as HTMLElement;
        const wrapperEl = document.querySelector('.filter-pills-popover .popover-wrapper') as HTMLElement;
        const triggerEl = this.filterTrigger ? this.filterTrigger.nativeElement as HTMLElement : null;
        if (!triggerEl || !contentEl) return;

        const box = triggerEl.getBoundingClientRect();
        contentEl.style.setProperty('top', `${box.bottom + 4}px`, 'important');
        contentEl.style.setProperty('left', `${box.left}px`, 'important');
        contentEl.style.setProperty('right', 'auto', 'important');
        contentEl.style.setProperty('width', '230px', 'important');
        contentEl.style.setProperty('max-width', 'calc(100vw - 16px)', 'important');
        contentEl.style.setProperty('z-index', '99999', 'important');
        contentEl.style.setProperty('overflow', 'visible', 'important');
        if (wrapperEl) wrapperEl.style.setProperty('overflow', 'visible', 'important');
    }

    private handleOutsideClick = (event: MouseEvent) => {
        const popoverEl = document.querySelector('.filter-pills-popover .popover-content');
        const target = event.target as HTMLElement;
        const triggerEl = this.filterTrigger ? this.filterTrigger.nativeElement as HTMLElement : null;

        const clickedInsidePopover = popoverEl && popoverEl.contains(target);
        const clickedTrigger = triggerEl && triggerEl.contains(target);
        const clickedSearchButton = target.closest('.search-btn') !== null;
        const clickedSearchInput = target.closest('#search-transaction-input') !== null;

        if (clickedTrigger || clickedSearchButton || clickedSearchInput) return;

        if (!clickedInsidePopover && this.filterPopoverRef) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.dismissedFilterByOutsideClick = true;
            this.filterPopoverRef.dismiss();
        }
    };

    private refocusSearchbar(delay: number = 150) {
        if (this.refocusSearchTxnInputTimer) {
            clearTimeout(this.refocusSearchTxnInputTimer);
        }

        this.refocusSearchTxnInputTimer = setTimeout(() => {
            if (this.searchbar) this.searchbar.setFocus();
            this.refocusSearchTxnInputTimer = null;
        }, delay);
    }

    onPillSelectedFromPopover(pillId: string) {
        this.filterDismissedViaSelection = true;
        this.filterByPills = this.filterByPills.map(p => ({
            ...p,
            active: pillId !== null && p.id === pillId
        }));

        if (this.searchTerm?.trim()) {
            this.retrieveTransactionList(undefined, undefined, pillId || '', false);
        }

        this.refocusSearchbar();
    }

    ngOnInit() {
        if (!this.authWrapper.isAuthenticated()) {
            this.authWrapper.unAuthenticatedRedirect();
            return;
        }
        this.term.valueChanges.subscribe(val => {
            this.searchTerm = val || '';
        });
    }

    ionViewWillEnter() {
        const returningFromTransactionTab = this.isTransactionTab;
        this.isTransactionTab = false;

        if (!returningFromTransactionTab) {
            this.showPills = false;
            this.searchTerm = '';
            this.term.setValue('', { emitEvent: false });
            this.filterByPills.forEach((p, i) => p.active = i === 0);
            this.selectedTxnStatus = '';
            this.selectedTxnDivision = '';
            this.selectedTxnStartDate = '';
            this.selectedTxnEndDate = '';
        }

        if (!this.authWrapper.isAuthenticated()) {
            this.authWrapper.unAuthenticatedRedirect();
            return;
        }

        this.filterByOrderType = this.util.filterByType ?? '';

        this.storageService.setFromSession().then(() => {
            if (!returningFromTransactionTab) {
                this.retrieveTransactionList();
            }
            this.navParams.data.refresh = false;

            if (this.platform.is('mobile')) this.bottomPixel = '80px';

            if (this.scrollSubscription) {
                this.scrollSubscription.unsubscribe();
                this.scrollSubscription = null;
            }

            this.scrollSubscription = this.content.ionScrollEnd.subscribe((data) => {
                if (!data) { this.showScrollToTop = false; }
                else {
                    const itemsInMobilePage = this.storageService.getItemsInMobilePage();
                    this.showScrollToTop = data['scrollTop'] > 0;
                    if (this.txnList.length <= itemsInMobilePage) {
                        this.util.checkHideFooter(this.txnList.length, '');
                    } else if (data['directionY'] === 'up') {
                        this.util.checkHideFooter(10, data['directionY']);
                    }
                    this.direction = data['directionY'];
                }
                this.changeDetectorRef.detectChanges();
            });
        });
    }

    ionViewWillLeave() {
        this.isLoading = false;
        this.isTransactionTab = true;
        this.safelyDismissLoading();
    }

    onSearchInput(event: any) {
        this.searchTerm = event?.target?.value || '';
    }

    onSearchClear() {
        if (this.filterPopoverRef) {
            this.filterPopoverRef.dismiss();
        }

        this.searchTerm = '';
        this.filterByPills.forEach((p, i) => p.active = i === 0);
        this.retrieveTransactionList(undefined, undefined, undefined, true, true);
    }

    refreshPage(refresher) {
        this.retrieveTransactionList();
        refresher.complete();
    }

    loadTxnOnScroll(infiniteScroll) {
        this.retrieveTransactionList(infiniteScroll);
    }

    retrieveTransactionList(infiniteScroll?: any, searchTerm?: string, filterByPillId?: string, showFilterByLoadingOverlay: boolean = true, force: boolean = false) {
        if (!navigator.onLine) {
            this.util.displayAlert(this.alertCtrl, "No internet", "There's no internet connection.");
            return;
        }

        if (infiniteScroll !== undefined && this.isLoading) {
            infiniteScroll.complete();
            return;
        }

        if (infiniteScroll == undefined) {
            if (this.isLoading && !force) return;
            this.isLoading = true;
            if (showFilterByLoadingOverlay) {
                this.safelyDismissLoading();
                this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Preparing request data");
            }
            this.pageIndex = 0;
        }

        const thisRequestId = ++this.requestSeq;
        const searchField = this.searchTerm.trim();
        const baseSearch = !searchField ? '' : (filterByPillId != null ? filterByPillId : (this.filterByPills.find(p => p.active)?.id || ''));
        
        this.transactionService.retrieveTxnHistoryList(this.pageIndex, this.storageService.getSalesrepCode(),
            this.selectedTxnStatus, this.selectedTxnDivision,
            this.selectedTxnStartDate, this.selectedTxnEndDate, baseSearch.trim(), searchField.trim(),
            this.filterByOrderType, this.storageService.getSettingId())
            .subscribe(
                (data) => {
                    if (thisRequestId !== this.requestSeq) {
                        if (infiniteScroll !== undefined) {
                            infiniteScroll.complete();
                        }
                        return;
                    }

                    let itemsInMobilePage = this.storageService.getItemsInMobilePage();
                    this.util.checkHideFooter(data.length, (this.searchTerm != "" && this.txnList.length <= itemsInMobilePage) ? 'down' : this.direction);
                    for (var i = 0; i < data.length; i++) {
                        data[i].u_txn_datetime = this.util.convertUTCDateToLocalDate(data[i].u_txn_datetime);
                    }

                    this.pageIndex++;
                    if (infiniteScroll == undefined)
                        this.txnList = data;
                    else {
                        infiniteScroll.complete();
                        this.txnList = this.txnList.concat(data);
                    }
                    this.realTimeCountdown();
                },
                (err) => {
                    if (infiniteScroll !== undefined) {
                        infiniteScroll.complete();
                    }

                    if (thisRequestId !== this.requestSeq) return;
                    
                    this.util.processError(this.loading ?? ({ dismiss: () => {} } as Loading), this.alertCtrl, err);
                    this.isLoading = false;
                },
                () => {
                    if (thisRequestId !== this.requestSeq) return;

                    try { if (this.loading) this.loading.dismiss(); }finally {
                        this.loading = null; 
                        this.isLoading = false;
                    }
                    
                });
    }

    setFilterType(filterType:any){
      this.filterByOrderType= filterType;
       this.retrieveTransactionList();
    }
    // goToTxnHistoryDetailDtl(txn: any){
    //     this.navCtrl.push(TxnHistoryDetail,txn);
    // }

    viewPopover(myEvent) {
        let popover = this.popoverCtrl.create('TxnHistFilterPopover', { status: this.selectedTxnStatus, division: this.selectedTxnDivision },);
        popover.present({
            ev: myEvent
        });
        popover.onDidDismiss((popoverData) => {
            if (popoverData != null && popoverData != undefined && popoverData != "") {
                this.selectedTxnStatus = popoverData.status;
                this.selectedTxnDivision = popoverData.division;
                this.selectedTxnStartDate = popoverData.startDate;
                this.selectedTxnEndDate = popoverData.endDate;
                this.retrieveTransactionList(undefined);
            }
        })
    }

    scrollToTop() {
        this.content.scrollToTop();
    }

    gotoPrevTab(e) {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.OrderList);
    }
    gotoNextTab(e) {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.OrderStatusList);
    }

    deleteKIVRecord(txn, index) {
        let arrButtons = [
            { text: 'Cancel', handler: () => {} },
            {
                text: 'Confirm', handler: () => {
                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Submitting order");
                    this.transactionService.deleteKIVOrder(txn.txn_no, this.storageService.getSalesrepCode(), this.storageService.getSettingId()).subscribe(
                        (data) => {
                            if (data == "1") {
                                this.txnList[index].status = 'C';
                            } else {
                                this.util.displayToast(this.toastCtrl, "Unable to delete the following order");
                            }
                        }, (err) => {
                            this.util.processError(this.loading, this.alertCtrl, err);
                        }, () => {
                            this.loading.dismiss();
                        }
                    )
                }
            }];

        this.util.displayConfirmation(this.alertCtrl, "Order cancellation", "Are you sure you want to cancel this order?", arrButtons);
    }

    uploadtoSAP(txn, index) {
        let arrButtons = [
            { text: 'Cancel', handler: () => {} },            {
                text: 'Confirm', handler: () => {
                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Submitting order");
                    this.transactionService.submitSalesOrder(this.storageService.getSalesrepCode(), txn.txn_no, 'R', this.storageService.getSettingId()).subscribe(
                        (data) => {
                            if(data.RDRESULT=="RD_SAP"){
                                // this.storageService.setSalesInd("");
                                // this.storageService.clearCustomer();
                                // this.storageService.clearOrder();
                                // this.navCtrl.pop();
                                this.util.displayAlert(this.alertCtrl, "", "Your order has been saved for Client SAP.");
                               // this.badgeService.resetBadge();
                            }
                            // -----TIC0839570--Error with duplicate order but Not found on Transaction history
                            else if(data.RDRESULT=="Updated"){
                                this.util.displayAlert(this.alertCtrl, "Order updated",
                                    "Your order has been updated successfully.");

                            }
                            // ---end----
                            else{
                            switch (data.ORDERSP.ORDER.STATUS) {
                                case "E":
                                    this.util.displayAlert(this.alertCtrl, "", "There's an issue with your submitted order. Error code: " + data.ORDERSP.ORDER.REMARKS);
                                    this.txnList[index].remarks = data.ORDERSP.ORDER.REMARKS;
                                    this.txnList[index].status = data.ORDERSP.ORDER.STATUS;
                                    break;
                                case "S":
                                    this.util.displayAlert(this.alertCtrl, "", "Your order has been submitted successfully.");
                                    this.txnList[index].so_no = data.ORDERSP.ORDER.SALES_ORDER_NO;
                                    this.txnList[index].status = data.ORDERSP.ORDER.STATUS;

                              if (this.storageService.getNumberOfAttachments() != 0) {
                                this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Sending Attachments...");
                                this.transactionService.ftpSendEmail(this.storageService.getPrincipalCode(), txn.txn_no, data.ORDERSP.ORDER.SALES_ORDER_NO, this.storageService.getSettingId()).subscribe(
                                  (result) => {
                                    if (result == false) { this.util.displayAlert(this.alertCtrl, "", "There's an error while sending the attachments."); }
                                    else { this.util.displayAlert(this.alertCtrl, "", "Attachments sent successfully."); }
                                  }, (err) => { this.util.processError(this.loading, this.alertCtrl, err); },
                                  () => { this.loading.dismiss(); }
                                )
                              }

                                    break;
                                default:
                                    this.util.displayAlert(this.alertCtrl, "", "We're unable to submit your order to SAP right now. Please try submitting again later.");
                                    break;
                            }
                        }
                        }, (err) => {
                            this.util.processError(this.loading, this.alertCtrl, err);
                        }, () => {
                            this.loading.dismiss();
                        }
                    )
                }
            }];

        this.util.displayConfirmation(this.alertCtrl, "Order submission", "Are you sure you want to submit this order to SAP?", arrButtons);
    }

    ftpSendEmail(txn, index) {
        let arrButtons = [
            { text: 'Cancel', handler: () => {} },
            {
                text: 'Confirm', handler: () => {
                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Sending Email");
                    this.transactionService.ftpSendEmail(this.storageService.getPrincipalCode(), txn.txn_no, txn.so_no, this.storageService.getSettingId()).subscribe(
                        (data) => {
                            if (data == false) { this.util.displayAlert(this.alertCtrl, "", "There's an error while sending the attachments."); }
                            else { this.util.displayAlert(this.alertCtrl, "", "Attachments sent successfully."); this.txnList[index].ftp_fail_ind = '0'; }
                        },
                        (err) => {
                            this.util.processError(this.loading, this.alertCtrl, err);
                        }, () => { this.loading.dismiss(); }
                    )
                }
            }
        ];
        this.util.displayConfirmation(this.alertCtrl, "Re-send attachments", "Are you sure you want to re-send the attachments of this order?", arrButtons);
    }


    txnStatusDetails(order: OrderHeaderModel) {
        // TODO: Clean module type
        let module_type = "", n_txn_no = "";
            module_type = "";
            n_txn_no = order.txn_no;
            this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Preparing request data");
        this.transactionService.retrieveOrderHistoryHeaderAndDetail(n_txn_no, this.storageService.getSalesrepCode(), this.storageService.getSettingId(), module_type)
            .subscribe(
                (order: OrderHeaderModel) => {
                    this.loading.dismiss();
                    if (order) {
                        let ord_status= order.txn_status;
                        if (ord_status == "K" || ord_status == QuoteStatus.QuoteRevision || ord_status == QuoteStatus.QuoteManagerRevision ||  ord_status == QuoteStatus.QuoteDraft) {
                            let customer: CustomerModel = <CustomerModel>{},
                                shipto: ShiptoModel = <ShiptoModel>{};

                            shipto.code = order.shipto_code;
                            shipto.name = order.shipto.name;
                            shipto.add_1 = order.shipto.add_1;
                            shipto.add_2 = order.shipto.add_2;
                            shipto.add_3 = order.shipto.add_3;
                            shipto.add_4 = order.shipto.add_4;
                            shipto.city = order.shipto.city;
                            shipto.province_code = order.shipto.province_code;
                            shipto.province_name = order.shipto.province_name;
                            shipto.postcode = order.shipto.postcode;
                            customer.cust_code = order.soldto_code;
                            customer.cust_name = order.soldto_name;

                            customer.salesorg = new SalesOrgModel();
                            customer.salesorg.salesorg = order.salesorg;
                            customer.salesorg.distchannel = order.distchannel;
                            customer.salesorg.division = order.division;
                            customer.salesorg.shipto_list = [];
                            customer.salesorg.shipto_list.push(shipto);

                            customer.payer = new PayerModel(); 
                            customer.payer.cust_code = order.soldto_code;
                            customer.payer.payer_code = order.payer_code;
                            customer.payer.payer_name1 = order.payer_name;
                            customer.pay_term_code = order.pay_term_code;
                            customer.pay_term_name = order.pay_term_name;
                            //TODO: missing matgrp4
                            customer.acct_grp = order.acct_grp;

                            this.storage.remove('uploadedOrder').then();
                            this.storageService.setCustomer(customer);
                            this.storageService.setOrder(order);
                            this.storageService.setSimulatedOrder(order)
                            if (ord_status == QuoteStatus.QuoteRevision || ord_status == QuoteStatus.QuoteDraft || ord_status == QuoteStatus.QuoteManagerRevision) {
                                this.openQuotaionPopup(order);
                            }
                            else {
                            this.badgeService.resetBadgeAndCountOrder(order);
                            this.storageService.setSalesInd(order.sales_ind);
                            this.storage.set('uploadedOrder', order).then(() => {
                            this.events.publish('update-order-detail', "start");                                
                            this.navCtrl.parent.select(Page.OrderList);
                            });
                           }                           
                        }
                        else if(ord_status == QuoteStatus.QuoteApproved || ord_status == QuoteStatus.QuotePending || ord_status == QuoteStatus.QuoteExpired || ord_status == QuoteStatus.QuoteManagerApproved || ord_status == QuoteStatus.QuotePendingManagerApproval) {                        
                        this.openQuotaionPopup(order);
                        }
                        else {
                            let OrderStatusListModal = this.modalCtrl.create('OrderList',
                                { isModal: true, order: order, salesInd: this.storageService.getSalesIndFromOrder(order) },
                                { enableBackdropDismiss: false },
                            );

                            OrderStatusListModal.present();
                            OrderStatusListModal.onDidDismiss(() => {});
                        }
                    } else {
                        this.util.displayAlert(this.alertCtrl, "No order found", "There's no order found.");
                    }
                }
            )
    }
    openQuotaionPopup(order) {
        let qutationModal = this.modalCtrl.create('Quotation', { order: order, orderDetails: order.detail}, 
                        { enableBackdropDismiss: false,
                          cssClass: 'large-modal' 
                        });
                        qutationModal.present();
                        qutationModal.onDidDismiss((data) => {
                            if(data && data.action == 'X'){
                            if (data.txn_status == QuoteStatus.QuoteRevision || data.txn_status == QuoteStatus.QuoteDraft) {                          
                            order.valid_until=  order.valid_until.formatted
                            this.storageService.setOrder(order).then(() => {
                            this.storageService.setSimulatedOrder(order).then(() => {
                            this.badgeService.resetBadgeAndCountOrder(order);
                            this.storageService.setSalesInd(order.sales_ind);
                            this.storage.set('uploadedOrder', order).then(() => {
                            this.events.publish('update-order-detail', "start");                                
                            this.navCtrl.parent.select(Page.OrderList);
                            });
                            }) 
                            });                            
                            }
                            }
                            if(data && data.action =='S'){
                                this.storageService.clearCustomer();
                                this.storageService.clearOrder();
                                this.badgeService.resetBadge();
                                this.retrieveTransactionList();
                            }
                       });
    }

    copyTxn(txn, index) {
        let copyConfirmation = this.modalCtrl.create('CopyOrderConfirmationPage', { txn_no: txn.txn_no }, { enableBackdropDismiss: true, cssClass: 'page-copy-order-confirmation' });
        copyConfirmation.present();
        copyConfirmation.onDidDismiss((data) => {
            if (data?.action === ModalAction.Proceed) {
                if (data.isSameCustomer === true) {
                    let copyOrderInfo: CopyOrderInfoModel;
                    copyOrderInfo = data.data;

                    let selectedCustomer: CustomerModel = new CustomerModel();
                    selectedCustomer.cust_code = copyOrderInfo.cust_code;
                    selectedCustomer.cust_name = copyOrderInfo.cust_name;

                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Setting customer");
                    this.customerService.retrieveSalesOrgAndShiptoList(this.storageService.getSalesrepCode(), copyOrderInfo.cust_code, copyOrderInfo.orderReason, this.storageService.getSettingId()).subscribe(
                        (res: SalesOrgModel[]) => {
                            selectedCustomer.salesorg = res.find((r) => r.salesorg === copyOrderInfo.salesorg 
                                                                        && r.distchannel === copyOrderInfo.distchannel 
                                                                        && r.division === copyOrderInfo.division);

                            selectedCustomer.salesorg.shipto_list = selectedCustomer.salesorg.shipto_list.filter(
                                                                        x => x.cust_code === copyOrderInfo.cust_code && x.code === copyOrderInfo.shipto_code
                                                                    );

                            this.custRestrictionPolicy = this.storageService.checkCustomerRestrictionPolicy();
                            if (this.custRestrictionPolicy && this.custRestrictionPolicy.trim() !== "") {
                                this.getCustomerRestriction(this.custRestrictionPolicy, selectedCustomer.cust_code, selectedCustomer.salesorg.salesorg, selectedCustomer.salesorg.distchannel, selectedCustomer.salesorg.division).then(
                                    (isValid) => {
                                        if (!isValid) {
                                            return;
                                        } else {
                                            this.customerService.retrievePayerList(this.storageService.getSalesrepCode(), selectedCustomer.cust_code, selectedCustomer.salesorg.salesorg, selectedCustomer.salesorg.distchannel, selectedCustomer.salesorg.division, this.storageService.getSettingId()).subscribe(
                                                (res: PayerModel[]) => {
                                                    selectedCustomer.payer = res.find((r) => r.cust_code === copyOrderInfo.cust_code && r.payer_code === copyOrderInfo.payer_code);
                                                    selectedCustomer.pay_term_code = copyOrderInfo.pay_term_code;
                                                    this.storage.set("orderReason", copyOrderInfo.orderReason);
                                                    this.storageService.setCustomer(selectedCustomer);
                                                    this.copyOrder(
                                                    copyOrderInfo.txn_no
                                                    , copyOrderInfo.cust_code
                                                    , copyOrderInfo.salesorg
                                                    , copyOrderInfo.shipto_code
                                                    , copyOrderInfo.division
                                                    , copyOrderInfo.distchannel
                                                    , copyOrderInfo.pay_term_code
                                                    , copyOrderInfo.orderReason
                                                    , copyOrderInfo.payer_code
                                                    , copyOrderInfo.affiliate_order
                                                    );
                                                }, (err) => {
                                                    this.loading.dismiss();
                                                }, () => {
                                                    //
                                                }
                                            );
                                        }
                                    }
                                );
                            } else {
                                this.customerService.retrievePayerList(this.storageService.getSalesrepCode(), selectedCustomer.cust_code, selectedCustomer.salesorg.salesorg, selectedCustomer.salesorg.distchannel, selectedCustomer.salesorg.division, this.storageService.getSettingId()).subscribe(
                                    (res: PayerModel[]) => {
                                        selectedCustomer.payer = res.find((r) => r.cust_code === copyOrderInfo.cust_code && r.payer_code === copyOrderInfo.payer_code);
                                        selectedCustomer.pay_term_code = copyOrderInfo.pay_term_code;
                                        this.storage.set("orderReason", copyOrderInfo.orderReason);
                                        this.storageService.setCustomer(selectedCustomer);
                                        this.copyOrder(
                                        copyOrderInfo.txn_no
                                        , copyOrderInfo.cust_code
                                        , copyOrderInfo.salesorg
                                        , copyOrderInfo.shipto_code
                                        , copyOrderInfo.division
                                        , copyOrderInfo.distchannel
                                        , copyOrderInfo.pay_term_code
                                        , copyOrderInfo.orderReason
                                        , copyOrderInfo.payer_code
                                        , copyOrderInfo.affiliate_order
                                        );
                                    }, (err) => {
                                        this.loading.dismiss();
                                    }, () => {
                                        //
                                    }
                                );
                            }
                        }, (err) => {
                            this.loading.dismiss();
                        }
                    );
                } else {
                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Checking for previous session's order");
                    // 1. Check previous temp order
                    this.transactionService.retrieveTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId())
                        .subscribe((data) => {
                            this.loading.dismiss();
                            if (data.txn_no !== null) {
                                this.displayTempOrderConfirmation("Previous order found", "You've a pending order from previous session. Do you wish to remove previous order?", txn);
                                return;
                            } else {
                                if (txn.sales_ind === "C" && this.storageService.getSettingId() !== SettingId.SG && this.storageService.getSettingId() !== SettingId.HK){
                                    this.getOrderReason(txn);
                                } else {
                                    this.processCopyOrder(txn);
                                }
                            }
                        },
                        () => { 
                            this.loading.dismiss(); 
                        }
                    );
                }
            } else {
                return;
            }
        });
    }

    displayTempOrderConfirmation(title: string, message: string, txn: TransactionModel) {
        let arrButtons = [{ text: "No", role: 'no', handler: () => { return true; } },
        {
            text: "Yes", role: 'yes', handler: () => {
                this.transactionService.deleteTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId()).subscribe(
                    (data) => {
                        this.badgeService.resetBadge();
                        this.storageService.clearCustomer();
                        this.storageService.clearOrder();
                        if (txn.sales_ind == "C" && this.storageService.getSettingId() !== SettingId.SG && this.storageService.getSettingId() !== SettingId.HK) {
                            this.getOrderReason(txn);
                        } else {
                            this.processCopyOrder(txn);
                        }
                    }
                );
            }
        }]
        this.util.displayConfirmation(this.alertCtrl, title, message, arrButtons);
    }

    getOrderReason(txn) {
        this.customerService.retrieveOrderReasonList(this.storageService.getSalesrepCode(), this.storageService.getSettingId()).subscribe(
            (data) => {
                if (data.length > 0) {
                    let orderReasonModal = this.modalCtrl.create('OrderReason',
                        { data: data, original_order_reason: txn.order_reason },
                        { enableBackdropDismiss: false }
                    );
                    orderReasonModal.present();
                    orderReasonModal.onDidDismiss((p) => {
                        switch (p.action) {
                            case "cancel":
                                return;
                            case "proceed":
                                this.storageService.setSalesInd(txn.sales_ind);

                                this.processCopyOrder(txn, p.order_reason.order_reason_code);
                        }
                    });
                } else {
                    this.util.displayAlert(this.alertCtrl, "", "Not authorized to create consignment order (order reason not configured)");
                }

            }
        );
    }

    processCopyOrder(txn, selected_order_reason?: string) {
        var s_order_reason = selected_order_reason == undefined ? "": selected_order_reason;
        //select customer
        let allCustomerModal = this.modalCtrl.create('AllCustomer', {data:s_order_reason},{ enableBackdropDismiss: false });
        allCustomerModal.present();
        allCustomerModal.onDidDismiss((p) => {
            switch (p.action) {
                case "cancel":
                    this.selectedCustCode = "";
                    return;
                case "select":
                    this.selectedCustCode = p.custInfo.cust_code;

                    //check salesorg + shipto + payer
                    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Checking multiple payer list");

                    this.customerService.retrieveSalesOrgAndShiptoList(this.storageService.getSalesrepCode(), this.selectedCustCode, s_order_reason ,this.storageService.getSettingId())
                        .subscribe(
                            (data) => {
                                this.salesorg = data;
                               this.loading.dismiss()
                                if (this.salesorg.length == 0) {
                                    this.util.displayAlert(this.alertCtrl, "Shipto not found",
                                        "There's no shipto found for the selected customer (" + this.selectedCustCode + ")");
                                } else if (this.salesorg.length == 1 && this.salesorg[0].shipto_list.length == 1) {
                                    this.selectedSalesOrg = this.salesorg[0].salesorg;
                                    this.selectedShiptoCode = this.salesorg[0].shipto_list[0].code;
                                    this.selectedDivision = this.salesorg[0].division;
                                    this.selectedDistchannel = this.salesorg[0].distchannel;

                                    let customerN: CustomerModel = <CustomerModel>{},
                                        shiptoN: ShiptoModel = <ShiptoModel>{};

                                    customerN = p.custInfo;
                                    shiptoN = this.salesorg[0].shipto_list[0];

                                    customerN.salesorg = <SalesOrgModel>{};
                                    customerN.salesorg.salesorg = this.selectedSalesOrg;
                                    customerN.salesorg.distchannel = this.selectedDistchannel;
                                    customerN.salesorg.division = this.selectedDivision;
                                    customerN.salesorg.shipto_list = [];
                                    customerN.salesorg.shipto_list.push(shiptoN);
                                    // STRY0018386- Same process for payer & billto code on copy txn
                                    this.retrievePayerList(customerN, txn.txn_no,s_order_reason)
                                } else if (this.salesorg.length > 0) {
                                    this.storage.set('selectedCustomer', <CustomerModel>{});
                                    let SalesOrgModal = this.modalCtrl.create('CustomerSalesOrg',
                                        { customer: p.custInfo, salesOrgList: this.salesorg },
                                        { enableBackdropDismiss: false }
                                    );
                                    SalesOrgModal.present();
                                    SalesOrgModal.onDidDismiss((q) => {
                                        if (!!q) {
                                            if (!!q.action) {
                                                switch (q.action) {
                                                    case ModalAction.Cancel:
                                                        return false;
                                                }
                                            }
                                            this.selectedCustCode = q.salesOrg.cust_code;
                                            this.selectedSalesOrg = q.salesOrg.salesorg;
                                            this.selectedShiptoCode = q.salesOrg.shipto_list[0].code;
                                            this.selectedDistchannel = q.salesOrg.distchannel;
                                            this.selectedDivision = q.salesOrg.division;

                                            let customerM: CustomerModel = <CustomerModel>{},
                                                shiptoM: ShiptoModel = <ShiptoModel>{};

                                            customerM = p.custInfo;
                                            shiptoM = q.salesOrg.shipto_list[0];

                                            customerM.salesorg = <SalesOrgModel>{};
                                            customerM.salesorg.salesorg = this.selectedSalesOrg;
                                            customerM.salesorg.distchannel = this.selectedDistchannel;
                                            customerM.salesorg.division = this.selectedDivision;
                                            customerM.salesorg.shipto_list = [];
                                            customerM.salesorg.shipto_list.push(shiptoM);
                                            this.retrievePayerList(customerM, txn.txn_no,s_order_reason)
                                        } else {
                                            this.util.displayAlert(this.alertCtrl, "Salesorg not found", "There's no salesorg found for the selected customer (" + this.selectedCustCode + ")");
                                        }
                                    })
                                }
                            },
                            (err) => { },
                            () => { })
            }
        })
    }
    
   async retrievePayerList(custInfo: CustomerModel, txn_no:any, s_order_reason:any ) {
    this.custRestrictionPolicy = this.storageService.checkCustomerRestrictionPolicy();
     if (this.custRestrictionPolicy && this.custRestrictionPolicy.trim() !== "") {
    const isValid = await this.getCustomerRestriction(this.custRestrictionPolicy,custInfo.cust_code, custInfo.salesorg.salesorg, custInfo.salesorg.distchannel, custInfo.salesorg.division);
    if (!isValid) return; 
    }
        this.customerService.retrievePayerList(this.storageService.getSalesrepCode(), custInfo.cust_code, custInfo.salesorg.salesorg, custInfo.salesorg.distchannel, custInfo.salesorg.division, this.storageService.getSettingId())
          .subscribe((payerData: PayerModel[]) => {
            if (_.isEmpty(payerData)) {
                this.util.displayAlert(this.alertCtrl, "Missing payer", "Payer is missing for this customer. Please contact support team for further assistance.");
                return;
            }
            
            this.payer = payerData;
            if (this.payer.length > 1) {
              this.showPayerPopup(custInfo, txn_no, s_order_reason);
            } else {
                if (_.isEmpty(this.payer[0].term) && this.storageService.getSalesInd() !== SalesInd.CONSIGNMENT) {
                    this.util.displayAlert(this.alertCtrl, "Missing Payment Term", "Payer Payment Term is missing for this customer. Please contact support team for further assistance.");
                    return;
                }

                custInfo.payer = this.payer[0];
                if (this.storageService.getSalesInd() === SalesInd.CONSIGNMENT) {
                    custInfo.pay_term_code = 'Z999';
                    custInfo.pay_term_name = 'Within 999 days Due Net';
                } else {
                    custInfo.pay_term_code = this.payer[0].term;
                    custInfo.pay_term_name = this.payer[0].payment_term_name;
                }
                this.selectedPayTerm = this.payer[0].term;
                this.storageService.setCustomer(custInfo);

                this.copyOrder(txn_no, this.selectedCustCode, this.selectedSalesOrg, this.selectedShiptoCode, this.selectedDivision, this.selectedDistchannel, this.selectedPayTerm, s_order_reason,this.payer[0].payer_code, this.payer[0].affiliate_payer);
            }
          })
      }

    // STRY0018386- Same process for payer & billto code on copy txn
    showPayerPopup(custInfo: CustomerModel,txn_no,s_order_reason){ let PayerModal = this.modalCtrl.create('CustomerPayer',{customer:custInfo , payerList: this.payer }, { enableBackdropDismiss: false });
        PayerModal.present();
        PayerModal.onDidDismiss((data) => {
            switch (data.action) {
                case ModalAction.Cancel:
                    return false;
                case ModalAction.Proceed:
                    if (_.isEmpty(data.payer.term) && this.storageService.getSalesInd() !== SalesInd.CONSIGNMENT) {
                        this.util.displayAlert(this.alertCtrl, "Missing Payment Term", "Payer Payment Term is missing for this customer. Please contact support team for further assistance.");
                        return;
                    }

                    custInfo.payer = data.payer;
                    if (this.storageService.getSalesInd() === SalesInd.CONSIGNMENT) {
                        custInfo.pay_term_code = 'Z999';
                        custInfo.pay_term_name = 'Within 999 days Due Net';
                    } else {
                        custInfo.pay_term_code = this.payer[0].term;
                        custInfo.pay_term_name = this.payer[0].payment_term_name;
                    }
                    this.selectedPayTerm = data.payer.term;

                    this.storageService.setCustomer(custInfo);
                    this.copyOrder(txn_no, this.selectedCustCode, this.selectedSalesOrg, this.selectedShiptoCode, this.selectedDivision, this.selectedDistchannel, this.selectedPayTerm, s_order_reason, data.payer.payer_code, data.payer.affiliate_payer);
                    return;
            }
        });
    }

    // STRY0018386- Same process for payer & billto code on copy txn - payer_code is passed for this story
    copyOrder(to_copy_txn_no, cust_code, sales_org, shipto_code, division, distchannel, payment_term, selected_order_reason, payer_code, affiliate_order) {
        let order: OrderHeaderModel = <OrderHeaderModel>{};
        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Generating copy order");

        //TODO: Why define affiliate_order then check undefined? Api not return same schema?
        if(affiliate_order == undefined){affiliate_order= false}

        this.transactionService.copyOrder(to_copy_txn_no, this.storageService.getSalesrepCode(), cust_code, sales_org, shipto_code, division, distchannel, payment_term, selected_order_reason,payer_code, affiliate_order, this.storageService.getUserId(), this.storageService.getSettingId())
            .subscribe((data) => {
                this.transactionService.retrieveTempOrder(this.storageService.getSalesrepCode(), this.storageService.getUserId(), this.storageService.getSettingId())
                    .subscribe((header) => {
                        order = _.cloneDeep(header);

                        this.transactionService.retrieveTempOrderDetail(data, this.storageService.getSettingId())
                            .subscribe((detail) => {
                                order.detail = _.cloneDeep(detail);

                                this.storage.remove('uploadedOrder').then(() => {
                                    this.storageService.setOrder(order).then(() => {
                                        this.storage.set('uploadedOrder', order).then(() => {
                                            this.events.publish('update-order-detail', "start", this.storageService.getToken());
                                            this.navCtrl.parent.select(Page.OrderList);
                                        });
                                    });
                                });
                            })
                    },
                    (err) => { },
                    () => { })
            },
            (err) => {
                this.util.processError(this.loading, this.alertCtrl, err);
                this.loading?.dismissAll();
            }, () => {
                this.loading?.dismissAll();
            });
    }

    orderStatusDetails(txn: any) {
        this.navCtrl.push('TrackOrderDetail', txn);
    }

    isPendingUnder30Mins(creationDateStr: string): boolean {
        let creationDate = new Date(this.parse24HourDate(creationDateStr));
        creationDate.setMinutes(creationDate.getMinutes() + 30); // Add 30 minutes
        const date = new Date();

        // Get the UTC time and then adjust for GMT+8
        const currentTime = new Date();

        // Calculate the difference between the creation time and current time
        const timeDifference = creationDate.getTime() - currentTime.getTime();
        return timeDifference > 0 ? true : false;
    }

    calculateCountdown(creationDateStr: string): string {
        let creationDate = new Date(this.parse24HourDate(creationDateStr));
        creationDate.setMinutes(creationDate.getMinutes() + 30); // Add 30 minutes

        const date = new Date();

        // Calculate the difference between the creation time and current time
        const timeDifference = creationDate.getTime() - date.getTime();

        if (timeDifference > 0) {
            // Time left in milliseconds
            const seconds = Math.floor(timeDifference / 1000);
            const minutes = Math.floor(seconds / 60);
            const remainingMinutes = String(minutes % 60).padStart(2, '0');
            const remainingSeconds = String(seconds % 60).padStart(2, '0');
            return `${remainingMinutes}:${remainingSeconds}`;
        }
        return "00:00"; // Return "00:00" if the countdown is over

    }

    parse24HourDate(dateStr: string): Date {
        const [datePart, timePart] = dateStr.split(' ');
        const [day, month, year] = datePart.split('-').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);

        return new Date(year, month - 1, day, hour, minute, second);
    }

    realTimeCountdown(): void {
        const interval = setInterval(() => {
            let pendingTransactions = 0;
            this.txnList.filter(x => x.status === 'P').forEach(txn => {
                let localDate = txn.u_txn_datetime;
                const countdown = this.calculateCountdown(localDate);
                txn.tick = countdown ; // Update the transaction object with the countdown
                if(countdown != "00:00")
                {
                    pendingTransactions++;
                }

                if (countdown == "00:01")
                {
                    this.transactionService.submitSalesOrder(this.storageService.getSalesrepCode(), txn.txn_no, 'R', this.storageService.getSettingId()).subscribe(
                        (data) => {
                            switch (data.ORDERSP.ORDER.STATUS) {
                                case "E":
                                    txn.remarks = data.ORDERSP.ORDER.REMARKS;
                                    txn.status = data.ORDERSP.ORDER.STATUS;
                                    break;
                                case "S":
                                    txn.so_no = data.ORDERSP.ORDER.SALES_ORDER_NO;
                                    txn.status = data.ORDERSP.ORDER.STATUS;
                                    break;
                                default:
                                    break;
                            }
                        })
                }
            });

            if (pendingTransactions === 0) {
                clearInterval(interval); // Stop the interval when there are no pending transactions
            }
        }, 1000); // Updates every second
    }
 getCustomerRestriction(policy:string,custcode: string, salesOrg: string, distChannel:string, division:string ): Promise<boolean> {
  return this.customerService.getCustomerRestrictionPolicy(custcode,salesOrg,distChannel, division, this.storageService.getSettingId()).toPromise()
    .then(
      (data) => {
        let policies= policy.split(";")
        const creditBlock = data?.CreditBlockCode;
        const salesBlock = data?.SalesBlockCode;
        if (salesBlock && policies[0]=="1") {
          this.util.displayAlert(this.alertCtrl, "Customer Blocked", data?.BlockReasonDescription);
          return false;
        }
        if (creditBlock === "X" && policies[1]=="1") {
          this.util.displayAlert(this.alertCtrl, "Customer Blocked", "This customer has been blocked by Credit Management");
          return false;
        }
        
        return true;
      }
    )
    .catch((error) => {
    this.util.displayAlert(this.alertCtrl, "Error", "Unable to retrieve customer restriction policy. Please try again later.");
    this.loading?.dismiss();
    return false;
  });
}
}




// WEBPACK FOOTER //
// ./src/pages/txn-history/txn-history.ts